import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Dashboard from "./Section/Dashboard/DashboardOne";

function Dashb() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const isLargeScreen = window.innerWidth >= 1024; // 1024px is a common breakpoint for laptops and larger

  const handleLogout = () => {
    setLoading(true); // Show spinner

    setTimeout(() => {
      localStorage.removeItem("authToken"); // Remove auth token
      setLoading(false); // Hide spinner
      navigate("/"); // Redirect to home page
    }, 3000); // 3 seconds delay
  };

  return (
    <div className='bg-[#0C2341]'>
      <Helmet>
        <title>AKT : Dashboard</title>
        <meta name="description" content="AKT Corp works with a concentrated set of leading suppliers bringing the best materials to our client's business needs. AKT Corp recognizes the need to support clients with high-quality products and marketing support." />
        <meta name="keywords" content="AKT Corp, Arabian Karim Trading Co. LLC, AKT Trading, AKT Corporation, Industrial Solutions, Industrial Equipment Suppliers, Building Materials Supplier, Offshore Industry Supplies, Oil & Gas Industry Supplies, Steel Solutions Supplier, Fiber Optics Solutions, Advanced Silicone Products, Industrial Lubricants Supplier, Fire-Rated Components, Thermal Insulation Solutions, Heavy Equipment Supplies, Electronics Industry Materials, Personal Care & Healthcare Solutions, Saudi Aramco Supplier, MARAFIQ Industrial Solutions, Saudi Arabia Railways Co Supplies, Petro Rabigh Industrial Products, Herkula Partner, Livesmart Partner, Momentive Products Supplier, Fenzi Industrial Solutions, Reliable Industrial Supplies, High-Quality Industrial Equipment, Heavy Machinery Lubricants, Advanced Sealing & Adhesives, Manufacturing Materials Supplier, Construction Materials Supplier, Electrical Components Supplier, Industrial Chemicals & Coatings, Request a Quote AKT Corp, Industrial Supplier in Saudi Arabia, Contact AKT Corp, Buy Industrial Materials Online, Fast & Reliable Industrial Supplies, Customized Industrial Solutions" />
      </Helmet>

      {isLargeScreen ? (
        <Dashboard />
      ) : (
        <div className="text-white text-center justify-center mt-56 mb-56">
          <p>Dashboard is Not Available <br /> on Mobile Screens.</p>
          <p className='mt-2'>Please Use Laptop or Desktop Screen</p>

          {loading ? (
            <div className="flex justify-center items-center mt-4">
              <div className="w-8 h-8 border-4 border-dashed rounded-full animate-spin border-white"></div>
            </div>
          ) : (
            <button 
              type="button" 
              onClick={handleLogout} 
              className="text-white bg-gradient-to-r from-purple-500 to-pink-500 hover:bg-gradient-to-l focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 mt-4"
            >
              Logout
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default Dashb;
